// React
import React from 'react';

// Prop types
import PropTypes from 'prop-types';

// Component
import ToDoTable from './ToDoTable';

// Const
import { RECIPROCAL, NONRECIPROCAL } from '../../../const';

// Redux
import { connect } from 'react-redux';
import { withRoomContext } from '../../../RoomContext';

// Mui styles
import { withStyles } from '@material-ui/core/styles';

// Mui core
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

// Mui icon
import CheckBoxOutlineBlankOutlinedIcon from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import FlagIcon from '@material-ui/icons/Flag';

const styles = () =>
	({
		root : {
			width           : '100%',
			height          : 'calc(100% - 2.5rem)',
			position        : 'relative',
			display         : 'flex',
			flexDirection   : 'column',
			borderRadius    : '20px',
			backgroundColor : '#e5e5e2',
			padding         : '2%'
		},
		wrapper : {
			display        : 'flex',
			justifyContent : 'center',
			height         : '100%'
		},
		flexGrid : {
			width           : 'calc(50% - 1.5rem)',
			height          : '100%',
			backgroundColor : 'white',
			borderRadius    : '5px',
			boxShadow       : '3px 3px 10px #aaa',
			padding         : '2%',
			display         : 'flex',
			flexDirection   : 'column'
		},
		flexGridCenter : {
			height     : '100%',
			display    : 'flex',
			alignItems : 'center'
		},
		flexGridIcon : {
			width  : '3rem',
			height : '3rem',
			color  : '#999898'
		},
		title : {
			color          : '#878686',
			fontSize       : '1rem',
			display        : 'flex',
			alignItems     : 'center',
			justifyContent : 'center'
		},
		iconTitle : {
			width       : '2rem',
			height      : '2rem',
			marginRight : '0.5rem'
		},
		noteContent : {
			height     : '1.5rem',
			display    : 'flex',
			alignItems : 'center'
		},
		note : {
			color      : '#878686',
			fontSize   : '0.6rem',
			marginTop  : '0.2rem',
			marginLeft : '0.4rem'
		},
		noteIcon : {
			width  : '1.5rem',
			height : '1.5rem',
			color  : '#c0d748'
		}
	});

const ToDoView = ({
	classes,
	onSelect
}) =>
{
	return (
		<Box className={classes.root}>
			<Box className={classes.wrapper}>
				<Box className={classes.flexGrid}>
					<Box className={classes.title}>
						<CheckBoxOutlineBlankOutlinedIcon className={classes.iconTitle} />
						<Typography>未対応</Typography>
					</Box>
					<Box className={classes.noteContent}>
						<FlagIcon className={`${classes.noteIcon} ${classes.activeIcon}`} />
						<Typography className={classes.note}>
							フラグをONにするとリストに送り続けます。
						</Typography>
					</Box>
					<ToDoTable todoType={RECIPROCAL} onSelect={onSelect}/>
				</Box>
				<Box className={classes.flexGridCenter}>
					<PlayArrowIcon className={classes.flexGridIcon} />
				</Box>
				<Box className={classes.flexGrid}>
					<Box className={classes.title}>
						<CheckBoxOutlinedIcon className={classes.iconTitle} />
						<Typography>対応済</Typography>
					</Box>
					<Box className={classes.noteContent} />
					<ToDoTable todoType={NONRECIPROCAL} onSelect={onSelect}/>
				</Box>
			</Box>
		</Box>
	);
};

ToDoView.propTypes =
{
	classes  : PropTypes.object.isRequired,
	onSelect : PropTypes.func.isRequired
};

const mapStateToProps = () =>
{
	return {

	};
};

const mapDispatchToProps = () =>
{
	return {

	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : () =>
		{
			return null;
		}
	}
)(withStyles(styles)(ToDoView)));
